import { withWidth } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import Attachment from '../Attachments/Attachment';
import CustomModal from '../../../components/Modals/Modal';
import messages from '../Attachments/messages';

import s from './EmbeddedAttachment.scss';

@injectIntl
@withStyles(s)
@connect(state => ({
  lesson: state.lessonDetails.lesson,
}))
@withWidth()
export default class EmbeddedAttachment extends React.Component {
  static propTypes = {
    item: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      uploadedDate: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      mimetype: PropTypes.string.isRequired,
    }).isRequired,
    width: PropTypes.string,
    withVideo: PropTypes.bool.isRequired,
    isLast: PropTypes.bool,
  };

  static defaultProps = {
    width: '',
    isLast: false,
  };

  static contextTypes = {
    apiUrl: PropTypes.string,
    cloudfrontUrl: PropTypes.string,
  };

  state = {
    isOpen: false,
  };

  toggleModal = isOpen => {
    this.setState({
      isOpen,
    });
  };

  render() {
    const { item, width, withVideo, isLast } = this.props;
    const { isOpen } = this.state;
    const url = `/cloudfront/pdf-web-viewer/es5/web/viewer.html?file=${encodeURIComponent(
      `/cloudfront/${item.path}`,
    )}`;

    const iframe = <iframe src={url} className={s.iframe} title={item.name} />;

    if (!['xs', 'sm'].includes(width)) {
      return (
        <div className={classNames(s.root, { [s.last]: isLast })}>{iframe}</div>
      );
    }

    return (
      <div className={classNames(s.root, { [s.last]: isLast })}>
        <Attachment
          item={item}
          withVideo={withVideo}
          actionBtn={
            <Button
              data-test-id="rzOMtcWjM-A6KpI645KF3"
              variant="outlined"
              color="primary"
              size="large"
              onClick={() => this.toggleModal(true)}
              fullWidth
            >
              <FormattedMessage {...messages.open} />
            </Button>
          }
        />
        <CustomModal
          isOpen={isOpen}
          onClose={() => this.toggleModal(false)}
          classes={{ paper: classNames(s.modal, s.modalOverride) }}
        >
          {iframe}
          <ModalCloseBtn
            data-test-id="WR04U1eJ5ZGdOCyiia633"
            fitMobileLandscapeFullWidth
            onClick={() => this.toggleModal(false)}
          />
        </CustomModal>
      </div>
    );
  }
}
